// extracted by mini-css-extract-plugin
export default {"form_control":"style_form_control__s9VVB"};